import { render } from "./App.vue?vue&type=template&id=1363d86a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1363d86a&lang=css"

import exportComponent from "D:\\oomool_2019\\hands\\handsorder-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__